<template>
  <div class="tw-fixed tw-bottom-0 tw-left-24 tw-ml-2 tw-z-50 tw-cursor-pointer tw-bg-white tw-flex tw-rounded tw-items-center tw-px-2 tw-py-0.5"
       style="box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16); margin-bottom: 0.55rem;">
    <a href="http://m.me/PhasiCharoenDotCom">
      <img src="/images/messenger.svg" alt="messenger" class="tw-w-6 tw-h-6 tw-my-2 tw-ml-0.5 tw-mr-2"/>
    </a>
    <span class="tw-text-xs md:tw-text-sm tw-font-light">ติดต่อเราที่ <a class="tw-font-bold tw-text-black" href="tel:026637895">02 663 7895</a></span>
  </div>
</template>

<script>
export default {
  name: 'ContactBox'
}
</script>
